<template>
  <div class="recharge">
    <pageHeader title="充值">
      <template v-slot:headerRight>
        <span @click="goToRechargeRecord" style="color: #8e8e8e">充值记录</span>
      </template>
    </pageHeader>
    <div class="f5-bg"></div>
    <div class="main">
      <div
        class="no-game-chose"
        v-if="$route.query.page == 'quick' && !hasRecharge"
      >
        <van-cell
          title="请选择需要充值的游戏"
          is-link
          @click="goToRechargeSearch"
        />
      </div>

      <div v-else class="game-show-or-chose">
        <div class="game-selected">
          <img class="game-logo" :src="gameInfo.logoUrl" alt="" />

          <div class="game-info">
            <div class="game-title">
              <h1>{{ gameInfo.gameName }}</h1>
              <!-- <span class="discount">{{ gameInfo.discount }}</span> -->
            </div>

            <div class="platform-discount">
              <div class="platform">
                <img class="game-platform" :src="gameInfo.platUrl" alt="" />
                <div>
                  <span>{{ gameInfo.platName }}</span>
                  <span class="first-discount">
                    {{ discountInfo.rechargeFristName }}：{{
                      discountInfo.rechargeFristDiscount
                    }}
                  </span>
                  <span class="continue-discount">
                    {{ discountInfo.rechargeContinueName }}：{{
                      discountInfo.rechargeContinueDiscount
                    }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="f5-bg"></div>

      <div class="game-amount-box">
        <div class="account-form">
          <van-field
            v-model="account"
            label-align="right"
            center
            label="游戏账号"
            placeholder="请输入游戏账号"
            label-class="common-label"
          >
            <template #button>
              <van-icon name="cross" v-if="account && isLeyouRegister" @click="account = ''" />

              <van-popover
                v-model="showPopover"
                trigger="click"
                placement="bottom-end"
                :actions="actions"
                @select="onSelect"
              >
                <template #reference>
                  <van-icon name="arrow-down" v-if="!account" />
                </template>
              </van-popover>

              <div class="not-account" v-if="account && !isLeyouRegister" @click="findAccountDialog = true">
                <img src="@/assets/images/recharge-tip.png" alt="" />
                <span>账号不存在？</span>
              </div>
            </template>
          </van-field>
          <van-field
            v-model="amount"
            label-align="right"
            center
            clearable
            type="number"
            label="充值金额"
            placeholder="请输入充值金额"
            label-class="common-label"
            @input="oninput"
          >
          </van-field>
        </div>

        <div class="coupon">
          <!-- <van-coupon-cell
            :coupons="coupons"
            :chosen-coupon="chosenCoupon"
            @click="goToCouponPage"
            label-align="right"
            center
            label-class="common-label"
            :class="[coupons.length ? 'coupon-style' : '']"
          /> -->
          <van-field
            v-model="coupon"
            label-align="left"
            center
            clearable
            readonly
            label="优惠券"
            label-class="common-label"
          >
            <template #button>
              <van-icon name="arrow" />
            </template>
          </van-field>
          <span
            v-if="chosenCoupon == 0"
            @click="goToCouponPage"
            :class="['coupon-common', coupons.length ? 'coupon-style' : '']"
            >{{ coupons.length ? `${coupons.length}张可用` : "暂无可用" }}</span
          >
          <span
            v-else
            @click="goToCouponPage"
            :class="['coupon-common', true ? 'coupon-style' : '']"
            >-{{ chosenCoupon }}</span
          >
        </div>
      </div>

      <div class="recharge-desc">
        <div class="recharge-flow">
          <h1>充值流程：</h1>
          <div
            v-if="userInfo && userInfo.vipLevel <= 3"
            class="pic-text-tutorial"
            @click="rechargeGuideDialogVisible = true"
          >
            <span>图文教程</span>
            <img src="@/assets/images/tip.png" alt="" />
          </div>
        </div>

        <div class="desc-content">
          1、APP内下载游戏，并进入重新注册账号；<br />
          2、APP上选择对应游戏充值，到账代金券；<br />
          3、进入游戏内充值，支付方式选择代金券；<br />
          <em
            v-show="
              gameInfo.platName != '万梦' &&
              gameInfo.platName != '千寻' &&
              ($route.query.page != 'quick' || hasRecharge)
            "
            >4、当前平台：{{ gameInfo.platName }}；代金券有效期：{{
              platMapsValue
            }}；</em
          >
        </div>
      </div>
    </div>

    <div class="deposit_btns">
      <div class="deposit_btns_deposit">
        <div class="deposit_btns_balance">
          <span>应付金额：¥{{ realPyaMoney }}</span>
          <span>已节省：¥{{ discountMoney }}</span>
        </div>
        <van-button class="deposit" @click="recharge">充值</van-button>
      </div>
    </div>

    <rechagePayWayPopup
      v-if="rechagePayWayPopupVisible"
      v-model="rechagePayWayPopupVisible"
      :payInfo="payInfo"
    />
    <rechargeGuideDialog
      v-if="rechargeGuideDialogVisible"
      v-model="rechargeGuideDialogVisible"
    />
    <findAccountDialog  
      v-if="findAccountDialog"
      v-model="findAccountDialog"
      :platName="gameInfo.platName"
    />
  </div>
</template>

<script>
import pageHeader from "@/components/PageHeader";
import { requestMethods } from "@m/api";
import { mapGetters } from "vuex";
import rechagePayWayPopup from "@/components/RechagePayWayPopup";
import rechargeGuideDialog from "@/components/RechargeGuideDialog";
import findAccountDialog from "@/components/FindAccountDialog";
import { debounce } from "../../../libs/utils";
export default {
  components: {
    pageHeader,
    rechagePayWayPopup,
    rechargeGuideDialog,
    findAccountDialog
  },
  computed: {
    ...mapGetters(["uuid", "userInfo", "configInfo"]),
    platMapsValue() {
      const platInfos = {
        果盘: "30天",
        3011: "90天",
        当乐: "长期",
        天宇: "长期",
        爱趣: "长期",
        "91玩": "长期",
        "98sy": "长期",
      };
      return platInfos[this.gameInfo.platName];
    }
  },
  data() {
    return {
      account: "",
      amount: "",
      coupon: "",
      gameInfo: {},
      coupons: [],
      chosenCoupon: 0,
      realPyaMoney: 0,
      discountMoney: 0,
      backAmount: 0,
      showList: false,
      showPopover: false,
      actions: [],
      isLeyouRegister: true,
      rechagePayWayPopupVisible: false,
      hasRecharge: false,
      rechargeGuideDialogVisible: false,
      discountInfo: {},
      findAccountDialog: false,
      hasPhoneBlock: false
    };
  },
  async created() {
    if (this.$route.query.page != "quick") {
      this.initRechargeGame();
    } else {
      await this.getRechargeeList();
    }
    if (this.$route.query.pageFrom == "coupon") {
      this.amount = this.$route.query.amount;
      this.getCouponUseList();
      const { chosenCoupon, amount, gameAccountNo, userCouponId } =
          this.$route.query;
        console.log(chosenCoupon, "chosenCoupon");
        this.chosenCoupon = chosenCoupon;
        this.amount = amount;
        this.account = gameAccountNo;
        this.userCouponId = userCouponId;
        this.getDiscountMoney();
    }
    this.getDiscountByGameId();
    this.rechargeAmountList();
    if(this.account) {
      this.isLeyouRegisterCheck()
    }
    this.hasCouponPhoneBlock()
  },
  methods: {
    oninput: debounce(function () {
      console.log(this.amount, "amount");
      this.userCouponId = "";
      this.coupons = [];
      this.chosenCoupon = 0;
      if (this.amount) {
        this.getCouponUseList();
        this.getDiscountMoney();
        this.isLeyouRegisterCheck()
      }
    }, 500),

    hasCouponPhoneBlock() {
      let content = this.configInfo.filter(e => e.name == 'Config_Coupon_Data')[0].content
      let PhoneBlackList = JSON.parse(content).PhoneBlackList
      this.hasPhoneBlock = PhoneBlackList.includes(this.userInfo.phone)
    },
    /**
     * 获取可用优惠券列表
     */
    async getCouponUseList() {
      try {
        const { data, totalCount } = await requestMethods(
          "/modules/coupon/userCoupon/useCouponList.htm",
          "post",
          {
            uuid: this.uuid,
            gameAccountNo: this.account,
            amount: this.amount,
            gameId: this.gameInfo.gameId,
          }
        );
        this.coupons = data || [];
      } catch (error) {
        this.$toast({
          message: error.message,
          position: "bottom",
        });
      }
    },

    /**
     * 查询充值记录
     */
    async getRechargeeList() {
      try {
        const { data, totalCount } = await requestMethods(
          "/modules/RechargeAction/getRechargeList.htm",
          "post",
          {
            uuid: this.uuid,
            appType: "WM",
            currentPage: 1,
            pageSize: 10,
          }
        );
        if (data.length) {
          this.hasRecharge = true;
          let info = data[0];
          const {
            gameName,
            discount,
            logoUrl,
            channelName,
            channelLogoUrl,
            gameId,
            id,
            gameAccount,
          } = info;
          this.gameInfo = {
            gameName,
            platUrl: channelLogoUrl,
            platName: channelName,
            discount,
            logoUrl,
            gameId,
            rechargeGameId: id,
          };
          this.account = gameAccount;
        } else {
          this.hasRecharge = false;
        }
      } catch (error) {
        this.$toast({
          message: error.message,
          position: "bottom",
        });
      }
    },

    /**
     * 获取游戏折扣
     */
    async getDiscountByGameId() {
      try {
        const { data } = await requestMethods(
          "/modules/web/game/getDiscountByGameId.htm",
          "post",
          {
            uuid: this.uuid,
            gameId: this.gameInfo.gameId,
          }
        );
        const { game } = data;
        this.discountInfo = game;
      } catch (error) {
        this.$toast({
          message: error.message,
          position: "bottom",
        });
      }
    },

    /**
     * 获取某游戏充值的历史账号列表
     */
    async rechargeAmountList() {
      try {
        const { data } = await requestMethods(
          "/modules/RechargeAction/rechargeAmountList.htm",
          "post",
          {
            uuid: this.uuid,
            gameId: this.gameInfo.gameId,
          }
        );
        if (data.length) {
          this.actions = data.map((e) => {
            return {
              text: e,
            };
          });
        } else {
          this.actions = [{ text: "暂无历史记录" }];
        }
      } catch (error) {
        this.$toast({
          message: error.message,
          position: "bottom",
        });
      }
    },

    /**
     * 跳转优惠券选中列表
     */
    goToCouponPage() {
      if(this.hasPhoneBlock) {
        return
      }
      // return
      if (this.coupons.length) {
        this.$router.push({
          path: "/couponUse",
          query: {
            ...this.$route.query,
            gameId: this.gameInfo.gameId,
            amount: this.amount,
            gameAccountNo: this.account,
          },
        });
      }
    },

    /**
     * 充值按钮
     */
    async recharge() {
      await this.isLeyouRegisterCheck()
      if(!this.isLeyouRegister) {
        return
      }
      this.payInfo = {
        gameAcc: this.account,
        amount: this.backAmount,
        systemType: "IOS",
        uuid: this.uuid,
        gameId: this.gameInfo.gameId,
        rechargeGameId: this.gameInfo.rechargeGameId,
        userCouponId: this.userCouponId,
        apiUrl: "/modules/RechargeAction/doGameRecharge.htm",
      };
      this.rechagePayWayPopupVisible = true;
    },

    initRechargeGame() {
      const {
        gameName,
        platUrl,
        platName,
        discount,
        logoUrl,
        gameId,
        rechargeGameId,
        pageFrom,
        gameAccountNo,
      } = this.$route.query;
      this.gameInfo = {
        gameName,
        platUrl,
        platName,
        discount,
        logoUrl,
        gameId,
        rechargeGameId,
      };
      this.account = gameAccountNo;
      if (pageFrom && pageFrom == "coupon") {
        const { chosenCoupon, amount, gameAccountNo, userCouponId } =
          this.$route.query;
        console.log(chosenCoupon, "chosenCoupon");
        this.chosenCoupon = chosenCoupon;
        this.amount = amount;
        this.account = gameAccountNo;
        this.userCouponId = userCouponId;
        this.getDiscountMoney();
      }
    },

    /**
     * 游戏账号校验
     */
    async isLeyouRegisterCheck() {
      try {
        const { data } = await requestMethods(
          "/modules/RechargeAction/isLeyouRegister.htm",
          "post",
          {
            gameAcc: this.account,
            gameId: this.gameInfo.gameId,
          }
        );
        this.isLeyouRegister = data.isLeyouRegister;
      } catch (error) {
        this.$toast({
          message: error.message,
          position: "bottom",
        });
        this.isLeyouRegister = false
      }
    },

    /**
     * 获取折扣后金额
     */
    async getDiscountMoney() {
      try {
        const { data } = await requestMethods(
          "/modules/RechargeAction/getDiscountMoney.htm",
          "post",
          {
            gameAcc: this.account,
            gameId: this.gameInfo.gameId,
            amount: this.amount,
            uuid: this.uuid,
            userCouponId: this.userCouponId,
            appType: "WM",
          }
        );
        const { amount, maxLimit, realPyaMoney, minLimit, discountMoney } =
          data;
        this.realPyaMoney = realPyaMoney;
        this.discountMoney = discountMoney;
        this.backAmount = amount;
      } catch (error) {
        this.$toast({
          message: error.message,
          position: "bottom",
        });
      }
    },

    onChange(index) {
      this.showList = false;
      this.chosenCoupon = index;
    },

    onExchange(code) {
      this.coupons.push(coupon);
    },

    onSelect(action) {
      if (action.text == "暂无历史记录") {
        return;
      }
      this.account = action.text;
    },

    goToRechargeRecord() {
      this.$router.push({ path: "/rechargeRecord" });
    },

    goToRechargeSearch() {
      this.$router.replace({ path: "/rechargeSearch" });
    },
  },
};
</script>

<style lang="scss">
.recharge {
  background: #fff;
  .main {
    .game-show-or-chose {
      margin: 10px 0;
      padding: 20px 60px;

      .game-selected {
        display: flex;

        .game-logo {
          width: 132px;
          height: 132px;
          margin-right: 30px;
        }
        .game-info {
          .game-title {
            display: flex;
            align-items: center;
            margin-bottom: 17px;
            h1 {
              font-family: PingFangSC, PingFang SC;
              font-weight: 600;
              font-size: 34px;
              color: #212121;
              line-height: 48px;
              margin-right: 18px;
              max-width: 476px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }

          .platform-discount {
            display: flex;
            align-items: center;
            height: 50px;
            .platform {
              display: flex;
              align-items: center;
              .game-platform {
                width: 40px;
                height: 40px;
                margin-right: 12px;
              }
              span {
                color: #212121;
                font-size: 26px;
              }

              .first-discount {
                font-family: PingFangSC, PingFang SC;
                font-weight: 500;
                font-size: 26px;
                color: #a2a2a2;
                margin-right: 10px;
                margin-left: 20px;
                line-height: 1; /* 保证和图片对齐 */
              }
              .continue-discount {
                font-family: PingFangSC, PingFang SC;
                font-weight: 500;
                font-size: 26px;
                color: #a2a2a2;
                // line-height: 37px;
                line-height: 1; /* 保证和图片对齐 */
              }
            }
          }
        }
      }
    }
    .no-game-chose {
      height: 150px;

      .van-cell {
        height: 150px;
        line-height: 110px;

        .van-cell__right-icon {
          height: 110px;
          line-height: 110px;
        }
      }
    }
  }
  .f5-bg {
    width: 100%;
    height: 10px;
    background: #f5f5f5;
  }
  .game-amount-box {
    .account-form {
      padding: 30px 0;
    }
    .van-cell {
      background: #f5f5f5;
      height: 100px;

      &:first-child {
        margin-bottom: 2px;
      }

      .common-label {
        span {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 30px;
          color: #212121;
          line-height: 42px;
        }
      }
    }

    .van-field__button {
      line-height: 0px;
    }

    .not-account {
      display: flex;
      align-items: center;
      img {
        width: 30px;
        height: 30px;
        margin-right: 4px;
      }
      span {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 26px;
        color: #ff7a3e;
        line-height: 37px;
      }
    }

    .coupon {
      width: 100%;
      height: 100px;
      background: #f5f5f5;
      position: relative;

      .van-cell {
        line-height: 70px;

        .van-cell__title {
          margin-left: 54px;
          span {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 30px;
            color: #212121;
            line-height: 42px;
          }
        }
      }
      .coupon-common {
        color: #8f8f8f;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 30px;
        position: absolute;
        right: 72px;
        top: 34px;
      }
      .coupon-style {
        color: #ff7a3e;
      }
      // .van-cell__left-icon, .van-cell__right-icon {
      //   line-height: 70px;
      // }
    }
  }

  .recharge-desc {
    padding: 50px 30px 200px 30px;
    .recharge-flow {
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      padding-right: 20px;
      h1 {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 32px;
        color: #212121;
        line-height: 45px;
      }
      .pic-text-tutorial {
        display: flex;
        align-items: center;
        span {
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 26px;
          color: #ff7a3e;
          line-height: 37px;
        }
        img {
          width: 30px;
          height: 30px;
          margin-left: 10px;
        }
      }
    }
    .desc-content {
      margin-top: 8px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 28px;
      color: #8f8f8f;
      line-height: 40px;
    }
    .second-flow {
      display: block;
      margin-top: 50px;
      h1 {
        margin-bottom: 10px;
      }

      .coupon_desc_table {
        border-radius: 8px;
        border: 1px solid #e6e6e6;

        .table_thead {
          display: flex;
          align-items: center;
          border-bottom: 1px solid #e6e6e6;
          font-size: 28px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #7b7b7b;

          .thead_platform {
            height: 120px;
            line-height: 120px;
            width: 300px;
            text-align: center;
            border-right: 1px solid #e6e6e6;
          }
          .thead_exp {
            .exp_head {
              width: 388px;
              text-align: center;
              height: 60px;
              line-height: 60px;
              border-bottom: 1px solid #e6e6e6;
            }
            .exp_type {
              display: flex;
              align-items: center;
              span {
                width: 194px;
                height: 60px;
                line-height: 60px;
                text-align: center;
                &:last-child {
                  border-left: 1px solid #e6e6e6;
                }
              }
            }
          }
        }
        .table_tbody {
          font-size: 28px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #7b7b7b;
          box-sizing: border-box;
          .table_tbody_th {
            display: flex;
            align-items: center;
            border-bottom: 1px solid #e6e6e6;
            .tbody_th_td {
              width: 300px;
              height: 60px;
              line-height: 60px;
              text-align: center;
              border-right: 1px solid #e6e6e6;
            }
            .fs-22 {
              font-size: 22px;
            }
            .tbody_th_td_span {
              display: flex;
              align-items: center;
              span {
                width: 194px;
                height: 60px;
                line-height: 60px;
                text-align: center;
                &:last-child {
                  border-left: 1px solid #e6e6e6;
                }
              }
            }

            &:last-child {
              border-bottom: none;
            }
          }
        }
      }
    }
  }

  .deposit_btns {
    width: 100%;
    height: 140px;
    background: #f8f8f8;
    position: fixed;
    bottom: 0;
    z-index: 100;

    .deposit_btns_deposit {
      margin: 0 auto;
      width: 688px;
      height: 140px;
      background-size: 100% 100%;

      padding: 7px 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      box-sizing: border-box;

      .deposit_btns_balance {
        color: #ffffff;
        text-align: start;

        span {
          display: block;
          &:first-child {
            font-size: 30px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #212121;
            margin-bottom: 12px;
          }
          &:last-child {
            font-size: 26px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #8f8f8f;
          }
        }
      }
      .deposit {
        width: 200px;
        height: 80px;
        // padding: 4px 34px;
        border-radius: 40px;
        background: #ff7a3e;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #ffffff;
        font-size: 30px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/recharge/index.vue